var _path, _polygon, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDev(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "WebCoding",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M925,316.82V721.16A126.57,126.57,0,0,1,798.44,847.73H201.56A126.57,126.57,0,0,1,75,721.16V316.82Z",
    fill: "#ffffff",
    className: "color4fc3f7 svgShape"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "75 152.27 75 296.82 75 316.82 925 316.82 925 296.82 925 152.27 75 152.27",
    fill: "#3e3e3e",
    className: "color4e342e svgShape"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M306.82,239.55H152.27a10,10,0,0,1,0-20H306.82a10,10,0,0,1,0,20Z",
    fill: "#909090",
    className: "colora1887f svgShape"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M847.73,239.55H816.82a10,10,0,0,1,0-20h30.91a10,10,0,0,1,0,20Z",
    fill: "#818181",
    className: "colord32f2f svgShape"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M739.55,239.55H708.64a10,10,0,0,1,0-20h30.91a10,10,0,0,1,0,20Z",
    fill: "#9f9f9f",
    className: "colorffd740 svgShape"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M631.36,239.55H600.45a10,10,0,0,1,0-20h30.91a10,10,0,0,1,0,20Z",
    fill: "#6b6b6b",
    className: "color689f38 svgShape"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M385 452.05H145a10 10 0 1 1 0-20H385a10 10 0 0 1 0 20ZM769.85 677.18a10 10 0 0 1-7.07-17.07L840.86 582 762.78 504a10 10 0 1 1 14.14-14.15L862.07 575a10 10 0 0 1 0 14.15l-85.15 85.15A10 10 0 0 1 769.85 677.18ZM540.15 677.18a10 10 0 0 1-7.07-2.93L447.93 589.1a10 10 0 0 1 0-14.15l85.15-85.15A10 10 0 1 1 547.22 504L469.14 582l78.08 78.08a10 10 0 0 1-7.07 17.07ZM600.41 737.27a10 10 0 0 1-9.4-13.42l109.18-300a10 10 0 1 1 18.8 6.84l-109.18 300A10 10 0 0 1 600.41 737.27ZM385 587.27H145a10 10 0 0 1 0-20H385a10 10 0 0 1 0 20ZM385 722.5H145a10 10 0 0 1 0-20H385a10 10 0 0 1 0 20Z",
    fill: "#626262",
    className: "color2c7d99 svgShape"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDev);
export default __webpack_public_path__ + "static/media/dev.7a59a64b15b3623425215db58f1bdbe8.svg";
export { ForwardRef as ReactComponent };